import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl } from "../../helpers/constants";
import { getCookie, signout } from "../../helpers/cookies";

const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
        const token = getCookie("magiclock_admin_token");
        if (token) {
            headers.set('Authorization', `BEARER ${token}`)
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await customFetchBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 403) {
        signout(() => { window.location.href = "/login"; });
    }

    return result;
};

const trackingApis = createApi({
    reducerPath: 'trackingApis',
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 0,
    tagTypes: ["TrackingData", "UserTracking", "TrackingStats"],
    endpoints: build => ({
        // Get all staff with locations
        getAllTrackingData: build.query({
            query: () => ({
                url: "/users/staff/locations",
                method: "GET"
            }),
            transformResponse: (response) => response.result || response.data,
            providesTags: ["TrackingData"]
        }),

        // Get specific user's location
        getUserTrackingData: build.query({
            query: (userId) => ({
                url: `/users/${userId}/location`,
                method: "GET"
            }),
            transformResponse: (response) => response.result || response.data,
            providesTags: (result, error, userId) => [{ type: "UserTracking", id: userId }]
        }),

        // Get tracking statistics (calculated from staff locations)
        getTrackingStats: build.query({
            query: () => ({
                url: "/users/staff/locations",
                method: "GET"
            }),
            transformResponse: (response) => {
                // Calculate stats from the data
                const data = response.result || response.data;
                return {
                    totalConnected: data?.connectedUsers?.length || 0,
                    totalStaffOnline: data?.connectedUsers?.length || 0,
                    lastUpdated: new Date().toISOString(),
                };
            },
            providesTags: ["TrackingStats"]
        })
    }),
});

export const { 
    useGetAllTrackingDataQuery,
    useGetUserTrackingDataQuery,
    useGetTrackingStatsQuery
} = trackingApis;

export default trackingApis; 